import { Button } from "components/common";
import { useResendCancelDeletionEmail } from "hooks/useResendCancelDeletionEmail";
import { AlertTriangle } from "lucide-react";

interface ResendCancelDeletionToastProps {
  message: string;
  email: string;
  onCancelDeletion: () => void;
}

export const ResendCancelDeletionToast = ({
  message,
  email,
  onCancelDeletion,
}: ResendCancelDeletionToastProps) => {
  const {
    mutate: resendEmail,
    isPending,
    isRateLimited,
    formatRateLimitTime,
    rateLimitUntil,
  } = useResendCancelDeletionEmail();

  const handleResend = () => {
    resendEmail({ email });
  };

  const isResendDisabled = isPending || isRateLimited;

  return (
    <div className="flex flex-col gap-4 min-w-[280px] max-w-[360px] rounded-xl border border-primary/20 bg-gradient-to-br from-card to-muted p-4 shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_0_1px_rgba(255,255,255,0.05)]">
      <div className="flex gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 border border-primary/20">
          <AlertTriangle className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0 pt-0.5">
          <p className="text-sm font-medium text-foreground leading-snug">{message}</p>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Button
          type="button"
          variant="ghostBrand"
          color="brand"
          onClick={onCancelDeletion}
          className="w-full"
        >
          Cancel deletion
        </Button>
        <Button
          type="button"
          variant="ghost"
          color="gray"
          onClick={handleResend}
          disabled={isResendDisabled}
          isLoading={isPending}
          className="w-full text-sm"
        >
          {isRateLimited && rateLimitUntil
            ? `Resend email (${formatRateLimitTime(rateLimitUntil)})`
            : "Resend email"}
        </Button>
      </div>
    </div>
  );
};
